import { useFirebaseUser } from '../context/FirebaseUserContext';

/**
 * Hook for route guards that require authentication
 * Returns authentication state and helper flags
 */
export const useRequireAuth = () => {
    const { user, isLoading } = useFirebaseUser();
    
    const isAuthenticated = !!(user && user.uid);
    
    return {
        user,
        isLoading,
        isAuthenticated,
        // Helper flag: true if we're done loading and user is not authenticated
        shouldRedirect: !isLoading && !isAuthenticated
    };
};


